import { combineReducers } from 'redux'
import queueReducer from './queue/reducer'
import settingsReducer from './settings/reducer'
import notificationsReducer from './notifications/reducer'
import motdsReducer from './motds/reducer'

const reducer = combineReducers({
    queue: queueReducer,
    settings: settingsReducer,
    notifications: notificationsReducer,
    motds: motdsReducer,
})

export default reducer



// WEBPACK FOOTER //
// ./src/features/Toaster/data/reducer.js